// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2SdQD","cell":"ColumnAccessor_cell__20YPB","firstCellAccent":"ColumnAccessor_firstCellAccent__37myZ"};